<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <td style="width: 5px">Id</td>
          <th style="width: 120px">Changed On</th>
          <th style="width: 625px">Mapped SD tag</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let structuralData of auditPackedStructualDataDetailsViewModel
          "
        >
          <td style="font-size: 12px">{{ structuralData.id }}</td>
          <td style="font-size: 12px">
            {{ structuralData.changedOn | date: "MMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ structuralData.packedData }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
